import { render, staticRenderFns } from "./DashboardFidTransactions.vue?vue&type=template&id=73f06bf1&"
import script from "./DashboardFidTransactions.vue?vue&type=script&lang=js&"
export * from "./DashboardFidTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports